export default __webpack_public_path__ + "static/tf-807fc36c92b6bd1f90325fa1f7d55610.svg";